/**
 * Merges original quote requirements with conversational selections (deduped).
 */
export function mergeQuoteRequirements({
  requirements,
  photographyRequirements,
  ceremonies,
  addons,
  coverage,
} = {}) {
  const parts = mergeUniqueStrings(
    toList(requirements),
    toList(photographyRequirements),
    toList(ceremonies),
    toList(addons),
    toList(coverage)
  );
  return parts.join(", ");
}

function toList(value) {
  if (!value) return [];
  if (Array.isArray(value)) return value.filter(Boolean).map(String);
  return String(value)
    .split(/[,;]/)
    .map((part) => part.trim())
    .filter(Boolean);
}

function mergeUniqueStrings(...lists) {
  const seen = new Set();
  const result = [];
  lists.flat().forEach((item) => {
    const text = String(item).trim();
    if (!text) return;
    const key = text.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    result.push(text);
  });
  return result;
}

export default mergeQuoteRequirements;
